
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from "swiper/modules";

import Header from "../components/header";
import Footer from "../components/footer";

import '../assets/css/post-687.css'
import '../assets/css/post-912.css'
import "swiper/css/effect-fade"

import about01 from "../assets/images/Designed-for-life.png"

import banners01 from "../assets/images/abouts/AboutUS-1.webp"

import gallery01 from "../assets/images/abouts/About-us-gallery-3.png"
import gallery02 from "../assets/images/abouts/About-us-gallery-4.png"
import gallery03 from "../assets/images/abouts/About-us-gallery-5.png"
import gallery04 from "../assets/images/abouts/About-us-gallery-6.png"
import gallery05 from "../assets/images/abouts/About-us-gallery-7.png"
import gallery06 from "../assets/images/abouts/About-us-gallery-8.png"

import Aboutus02 from "../assets/images/About-us/How-Life-Unfolds-Here.webp"
import Aboutus01 from "../assets/images/About-us/Rooted-in-Regeneration-Grown-in-Symbiosis.webp"

const banners = [
    {src:banners01},
]

const gallerys = [
    {src:gallery01},
    {src:gallery02},
    {src:gallery03},
    {src:gallery04},
    {src:gallery05},
    {src:gallery06},
]



export default function About() {



    return (
    <div className="dody-container">
        <Header/>
        <section className='aboutus'>

        <div className='biome biome-687'>
        
            <div className="biome-element biome-element-31088fa e-flex e-con-boxed e-con e-parent e-lazyloaded">
                <div className="e-con-inner">
                    <div className="biome-element biome-element-204e737 e-con-full e-flex e-con e-child">

                        <div
                            className="biome-element biome-element-8b6c9ce biome-widget biome-widget-elementskit-heading animated ">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h1 className="ekit-heading--title elementskit-section-title "> Welcome to BIOME </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                className="biome-element biome-element-4f1f6db e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white animate-section-trigger">
                <div className="e-con-inner">

                    <div
                        className="biome-element biome-element-ed8c4d1 biome-widget biome-widget-elementskit-heading animated section-scroll-animation">

                        <div className="biome-widget-container">
                            <div className="ekit-wid-con">
                                <div
                                    className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                    <h2 data-anim="rotate"
                                        className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text">
                                        At Biome embrace the essence of a flourishing ecosystem, this
                                        agroforestry project unfolds like a vibrant tapestry, rich with possibilities.
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-bb60c9b e-con-full e-flex e-con e-child section-scroll-animation">
                            <div
                                className="biome-element biome-element-7915149 biome-widget biome-widget-image animated bdFadeLeft">
                                <div className="biome-widget-container">
                                    <img width="800" height="667" src={about01}
                                        className="attachment-full size-full wp-image-122" alt={about01} />
                                </div>
                            </div>
                        </div>
                        <div
                            className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child section-scroll-animation">
                            <div
                                className="biome-element biome-element-42c32f0 biome-widget biome-widget-text-editor animated ">
                                <div className="biome-widget-container">
                                     
                                   <h5 data-anim="fade-up" className='title-anim gsap-text'> The Launch of a Biodiverse Future We glimpsed the true meaning of happiness.</h5>
                                   <h5 data-anim="fade-up" className='title-anim gsap-text'> We beheld a land where mango groves flourished in abundance, ancient trees stood as sentinels of time, and a tranquil lake mirrored the skies a place where life could gently slow its pace.</h5>
                                   <h5 data-anim="fade-up" className='title-anim gsap-text'> We envisioned a sanctuary where dreams take flight, where the young and old alike could weave their passions into the fabric of life.</h5>
                                   <h5 data-anim="fade-up" className='title-anim gsap-text'> We imagined a world where simplicity meets sophistication, where convenience dances with exclusivity.</h5>
                                   <h5 data-anim="fade-up" className='title-anim gsap-text'> We saw the harmony of timeless beauty and modern ingenuity, intertwined like threads in an exquisite tapestry.</h5>
                                   <h5 data-anim="fade-up" className='title-anim gsap-text'> We dreamed of something extraordinary. We saw the birth of a new farm. We glimpsed the future a future rooted in nature’s embrace.</h5>
                                    
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>

            <div
                className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-element-bg-background animate-section-trigger">
                <div className="e-con-inner">

                    <div className="biome-element biome-element-8bcebe5 e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-bb60c9b e-con-full e-flex e-con e-child section-scroll-animation">
                            <div
                                className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h3 data-anim="rotate"
                                        className="biome-heading-title biome-size-default attr-text-white  animation__char_come gsap-text ">
                                        Who We Are</h3>
                                </div>
                            </div>

                            <div className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor">
                                <div className="biome-widget-container">
                                    <p data-anim="fade-up" className='title-anim gsap-text gsap-text attr-text-white'>
                                        Biome  is envisioned as a living sanctuary for people who want to slow
                                        down, live closer to the earth, and still remain deeply connected to a community. It
                                        is planned as a nature led settlement where forest canopies, food forests, fields,
                                        and trails hold more space than built form.
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div
                            className="biome-element biome-element-1fce1d2 e-con-full e-flex e-con e-child section-scroll-animation">
                            <div
                                className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h3 data-anim="rotate"
                                        className="biome-heading-title biome-size-default attr-text-white  animation__char_come gsap-text ">
                                        What We Stand For</h3>
                                </div>
                            </div>

                            <div
                                className="biome-element biome-element-42c32f0 biome-widget biome-widget-text-editor animated ">
                                <div className="biome-widget-container">
                                    <p data-anim="fade-up" className='title-anim gsap-text gsap-text attr-text-white'>
                                        The core intent is simple progress that regenerates. Every decision from masterplan
                                        to material choice aims to restore biodiversity, recharge water, and revive local
                                        livelihoods instead of eroding them. The project is designed to be
                                        climate resilient, low impact, and rooted in place, offering a model for rural urban
                                        living that future communities can learn from.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div
                className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded horizontal-container-panel">

                <div className="biome-background-slideshow animate-section-trigger">
                    <Swiper modules={[EffectFade, Autoplay]} effect="fade" fadeEffect={{ crossFade: true }}
                        autoplay={{ delay: 2000 }} loop={true} speed={1000} className="mySwiper">
                        {banners.map((banner, i) => (
                        <SwiperSlide>
                            <div className="biome-background-slideshow__slide">
                                <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                    style={{ backgroundImage: `url(${banner.src})` }}>
                                </div>
                            </div>
                        </SwiperSlide>

                        ))}

                    </Swiper>
                </div>

                <div className="e-con-inner">
                    <div
                        className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading animated fadeInUp">
                        <div className="biome-widget-container">
                            <h2 data-anim="rotate"
                                className="biome-heading-title biome-size-default  animation__char_come gsap-text ">Our
                                Promise</h2>
                        </div>
                    </div>
                    <div className="biome-element biome-element-48776fe e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-b750a21 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                            <div className="biome-widget-container">
                                <p data-anim="fade-up" className='title-anim gsap-text gsap-text attr-text-white'>
                                    Biome  is committed to being more than a plotted development. It is a
                                    long term commitment to land stewardship, water sensitivity, and a slower, more mindful
                                    way of living where every home, trail, and tree is part of one continuous, evolving
                                    ecosystem.
                                </p>

                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>

        </div>

        <div className="biome biome-24">
            <div
                className="biome-element biome-element-5c286c5 e-flex e-con-boxed e-con e-parent e-lazyloaded animate-section-trigger">

                <a href="/masterplan" target='_blank' className="e-con-inner">
                    <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <h6 data-anim="rotate"
                                    className="biome-heading-title biome-size-default  animation__char_come gsap-text ">How
                                    We Build</h6>
                            </div>
                        </div>

                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                            Architecture and Masterplanning</h2>

                                    </div>
                                </div>
                            </div>
                            <div className="biome-element biome-element-027d233 e-con-full e-flex e-con e-child ">
                                <div
                                    className="biome-element biome-element-077f5f3 biome-align-right biome-mobile-align-right biome-widget biome-widget-button animated fadeInUp">
                                    <div className="biome-widget-container">
                                        {/* <img className="attachment-full size-full-flex" src={MASTERPlan}
                                            alt={MASTERPlan} /> */}
                                        <p data-anim="fade-up"
                                            className='title-anim gsap-text gsap-text biome-align-left biome-mobile-align-left'>
                                            Architecture and masterplanning grow out of the site’s contours, waterflows, and
                                            existing trees. Built footprints are compact and carefully placed to protect
                                            natural drainage, preserve large tracts for rewilding and farming, and keep
                                            daily life visually and physically connected to green and blue corridors.
                                            Materials are largely local and earth based, ensuring thermal comfort,
                                            repairability, and a minimal footprint.
                                        </p>
                                        {/* <div className="biome-button-wrapper"><a
                                                className="biome-button biome-button-link biome-size-sm"
                                                href="/masterplan"><span className="biome-button-content-wrapper"><span
                                                        className="biome-button-icon"><i aria-hidden="true"
                                                            className="icon icon-right-arrow"></i></span><span
                                                        className="biome-button-text  animation__char_come gsap-text ">Explore</span></span></a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="biome-element  e-con-full e-flex e-con e-child first-story-section">
                            <div
                                className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full">
                                <img className="attachment-full size-full wp-image-122" src={Aboutus01} alt={Aboutus01} />
                            </div>

                        </div>
                    </div>

                </a>
            </div>

            <div
                className="biome-element biome-element-5c286c5 e-flex e-con-boxed e-con e-parent e-lazyloaded animate-section-trigger">

                <a href="/nestings" target='_blank' className="e-con-inner">
                    <div className="biome-element biome-element-47b1a33 e-con-full e-flex e-con e-child">
                        <div
                            className="biome-element biome-element-0f1b0ec biome-widget biome-widget-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <h6 data-anim="rotate"
                                    className="biome-heading-title biome-size-default  animation__char_come gsap-text ">How
                                    Life Unfolds Here</h6>
                            </div>
                        </div>

                        <div className="biome-element biome-element-0078ee0 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-9e1a0ed e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-43cdaa5 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                            Life at Biome is <span><span>designed around everyday</span></span> </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="biome-element biome-element-027d233 e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-077f5f3 biome-align-right biome-mobile-align-right biome-widget biome-widget-button animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up"
                                            className="biome-align-left biome-mobile-align-left title-anim gsap-text">
                                            Life at Biome  is designed around everyday experiences walking
                                            under a living canopy, cycling through food forests, gathering around a bonfire,
                                            practicing yoga in the open, watching children play in nature, or resting in a
                                            hammock between trees. Club Saluna, the caravan park, community lawns, and
                                            shared farming areas become anchors for social, cultural, and seasonal rhythms.
                                        </p>
                                        {/* <div className="biome-button-wrapper"><a
                                                className="biome-button biome-button-link biome-size-sm"
                                                href="/amenities"><span className="biome-button-content-wrapper"><span
                                                        className="biome-button-icon"><i aria-hidden="true"
                                                            className="icon icon-right-arrow"></i></span><span
                                                        className="biome-button-text  animation__char_come gsap-text ">Explore</span></span></a>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="biome-element  e-con-full e-flex e-con e-child first-story-section">
                            <div
                                className="biome-widget-container elementskit-section-title-wraper text_center biome-kit-5-height-full">
                                <img className="attachment-full size-full-flex" src={Aboutus02} alt={Aboutus02} />
                            </div>
                        </div>
                    </div>

                </a>
            </div>

        </div>

        <div className="biome biome-687">
            <div
                className="biome-element biome-element-03b44c8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white">
                <div className="e-con-inner">
                  
                    <div
                        className="biome-element biome-element-e67a910 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                        <div className="biome-widget-containers">
                            <div className="ekit-wid-con">
                                <div
                                    className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                    <h2 data-anim="rotate" className='title-anim gsap-text'>
                                        A Living Network of Regenerative Projects
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="biome-widget-container">
                        <p data-anim="fade-up" className='title-anim gsap-text'>
                            Biome Farms is envisioned not as a single site, but as a growing constellation of projects. Each
                            new farm, forest, or learning space will embody the same living principles restoring land,
                            feeding people, and inspiring a culture of care. Through partnerships, research, and
                            community led initiatives, we aim to seed regenerative landscapes wherever they are needed most.
                        </p>

                    </div>

                    <div className="biome-element biome-element-7928e5d e-grid e-con-full e-con e-child ">

                        {gallerys.map((gallery, i) => (
                        <div class="biome-element biome-element-dac90f79">
                            <img decoding="async" width="960" height="640" src={gallery.src}
                                className="attachment-full size-full wp-image-729" alt={gallery.src} />
                        </div>
                        ))}
                    </div>

                    <div
                        className="biome-element biome-element-e67a910 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                        <div className="biome-widget-containers">
                            <div className="ekit-wid-con">
                                <div
                                    className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                    <h2 data-anim="rotate" className='title-anim gsap-text'>
                                        Rooted in Regeneration. Grown in Symbiosis.
                                    </h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="biome-widget-container">

                        <p data-anim="fade-up" className='title-anim gsap-text'>
                            Biome Farms is a regenerative agriculture collective inspired by the structure of natural forests. At Biome we design living farm systems that integrate trees, shrubs, crops, and animals in layered harmony working with nature, not against it.
                        </p>
                        <p data-anim="fade-up" className='title-anim gsap-text'>
                           Our approach combines forest farming, Miyawaki micro forests, and syntropic agriculture to restore degraded land and increase biodiversity. We focus on building healthy soil, conserving water through swales and natural systems, and creating resilient polycultures that grow more fertile and abundant over time.
                        </p>
                         <p data-anim="fade-up" className='title-anim gsap-text'>
                            Beyond farming, we design spaces for learning, gathering, and community using natural materials and local knowledge. Every element from plants to pathways is created to support biodiversity and ecological balance.
                         </p>
                          <p data-anim="fade-up" className='title-anim gsap-text'>
                           Biome is more than a farm. It is a living system dedicated to restoration, abundance, and a more harmonious way of growing food.
                          </p>
                        {/* <p data-anim="fade-up" className='title-anim gsap-text'>
                            At our core, we follow principles of forest farming, where abundance emerges from balance.
                            We plant Miyawaki micro forests to regenerate degraded land and restore native biodiversity. We cultivate with the
                            syntropic approach, allowing the land to grow more fertile, complex, and abundant over time mirroring nature’s own succession.
                        </p>
                        <p data-anim="fade-up" className='title-anim gsap-text'>
                            Biome Farms thrives on dry land proof that even in arid landscapes, life can return. By
                            fostering diverse plant communities, capturing carbon, and enriching soil biology, we create systems that are not only
                            productive, but resilient in the face of climate change.
                        </p>
                        <p data-anim="fade-up" className='title-anim gsap-text'>
                            Our design extends beyond farming: every structure, path, and gathering space is built to
                            support biodiversity, education, and community. We use natural materials, local labour, and an ethic of reverence for place.
                        </p> */}
                    </div>

                    <div
                        className="biome-element biome-element-386b5e8  biome-widget biome-widget-text-editor animate-section-trigger">
                        {/* <div className="biome-widget-container">
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                At Biome Farms, we do not simply cultivate the land we listen to it. To the breath of the
                                soil, the whisper of roots, the memory held in every grain of sand. From this listening, a
                                new kind of agriculture is born one that does not impose, but invites one that does not extract, but restores. We are reimagining what it means to farm
                                by returning to the oldest teacher of all: the forest.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                Forest farming is our language of healing. It is not rows and repetition, but layers canopy,
                                understory, ground cover each life form playing a role in a greater, living composition.
                                Trees rise not in isolation, but in relationship. Shrubs protect. Roots weave. Birds carry
                                seed. This is food grown in community with the land, with the climate, with the creatures
                                who call it home.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                We draw on the quiet power of syntropic farming, a method shaped by the natural order of
                                succession. Here, planting is not static but temporal every species arriving with purpose,
                                giving before it receives. The soil becomes richer with each cycle, and fertility emerges
                                not from input, but from harmony. It is agriculture that builds itself, a forest that farms.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                We accelerate restoration through the Miyawaki method planting native micro forests that
                                grow dense and wild within a few short years. These thickets hold biodiversity like a
                                memory, cooling the land, calling back birdsong, and anchoring the spirit of wildness in the
                                heart of our farm. Even in the most degraded places, life returns fast, rooted, alive.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                Here, biodiversity is not a goal. It is the foundation. From nectar laden blossoms to deep
                                taproots that draw water from stone, every plant is chosen for what it gives to the system. Our polycultures bloom in succession, feeding pollinators across seasons, and weaving
                                resilience into the very structure of the land. In the dry places, we plant life that hum
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                Water is gathered, not lost captured in swales, held in shaded soils, recycled through plant
                                and sky. The land retains what it needs, and lets the rest flow with grace. Our farms do not
                                just endure the climate they cool it, soften it, make it kind again.
                                What we grow is not just food, but abundance. Fruits, roots, herbs, timber, medicine all
                                from the same living system. Diversity is our insurance, our economy, our offering. With
                                each season, the land yields more, and demands less.
                                Our architecture is light on the land structures built from earthen hands and renewable
                                minds. Spaces to gather, teach, prepare and sell but also to simply be. Buildings that
                                dissolve into the trees, that echo the curve of the hills and the hush of the forest floor.
                                Every wall, every roof, every path designed to belong.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                At Biome Farms, we are not farming the future we are remembering it. We are returning to a
                                way of being where food is not a product, but a relationship. Where land is not a resource,
                                but a relative. This is agriculture as ritual. As restoration. As reverence.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                Envisioned as a bold and transformative answer to the trials of urban existence, Biome
                                is a living symphony a masterpiece where nature and purpose converge in
                                perfect harmony. Destined to become the largest and most exquisitely planned agroforestry
                                project, it seeks to weave sustainability, beauty, and innovation into a timeless response
                                to the challenges of modern life.
                            </p>
                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                Rooted in the wisdom of syntropic farming and the Miyawaki method, this vision breathes life
                                into the soil, nurturing a thriving ecosystem that regenerates itself with grace and
                                abundance. It is a place where biodiversity flourishes, where forests rise like poetry
                                written by the earth, and where humanity finds its rhythm alongside nature’s eternal song.
                            </p>

                            <p data-anim="fade-up" className='title-anim gsap-text'>
                                Biome is not just a project it is a promise, a sanctuary of hope, and a dream
                                of a future where balance is restored, and life unfolds in its most vibrant form. Here,
                                amidst the whispers of trees and the embrace of fertile lands, we rediscover what it means
                                to truly live.
                            </p>
                        </div> */}

                        <div
                            className="biome-element biome-element-e67a910 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-containers">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h2 data-anim="rotate" className='title-anim gsap-text'>
                                            This is not just a farm. It is a movement.<br />
                                            A future rooted in listening, and grown in symbiosis.

                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  <Footer />
</div>
    )
}